/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-param-reassign */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AppLink from '../../shared/components/app-link/AppLink';
import { NAVIGATION_ROUTES } from '../../shared/constants/Constants';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import { debounce } from '../../api/apiUtils';

function FlightRescheduleList({ flightReschedules }) {
  const [transactionsList, setTransactionsList] = useState([]);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    setTransactionsList(flightReschedules);
  }, [flightReschedules]);

  const getFlightTicket = (txid) => {
    let route = NAVIGATION_ROUTES.FLIGHT.FLIGHT_TICKET_PAGE;
    route = route.replace(':transactionId', txid);
    return route;
  };
  const setSearchResults = debounce((val) => {
    let data = [...flightReschedules];
    if (val !== '') {
      data = data.filter((o) =>
        Object.keys(o.FlightRecord).some(
          (k) =>
            o.FlightRecord[k] !== null &&
            o.FlightRecord[k] !== undefined &&
            o.FlightRecord[k]
              .toString()
              .toLowerCase()
              .includes(val.toLowerCase()),
        ),
      );
    }
    setTransactionsList(data);
  }, 500);
  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchText(value);
    setSearchResults(value);
  };
  return (
    <section className="flight-canx-list p-2 ">
      <div className="flight-canx-list_container ms-1">
        <div>
          <div className="mb-3 d-flex">
            <div style={{ width: '300px' }}>
              <AppTextInput
                value={searchText}
                label="search"
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th>Tx.Id</th>
              <th>Tx.Date</th>
              <th>Agent ID</th>
              <th>Reference Tx Id</th>
              <th>Origin</th>
              <th>Destination</th>
              <th>BookingDate</th>
              <th>Total Amount</th>
              <th>View Ticket</th>
            </tr>
          </thead>
          <tbody>
            {transactionsList.map((transaction) => (
              <tr key={transaction.Txid}>
                <td>{transaction.Txid}</td>
                <td>{transaction.TxDate}</td>
                <td>{transaction.AgentId}</td>
                <td>
                  <AppLink
                    linkText={transaction.ReferenceTxId}
                    isLink
                    target="_blank"
                    href={getFlightTicket(transaction.ReferenceTxId)}
                  />
                </td>
                <td>{transaction.FlightRecords.FlightRecord[0].Origin}</td>
                <td>{transaction.FlightRecords.FlightRecord[0].Destination}</td>
                <td>{transaction.FlightRecords.FlightRecord[0].BookingDate}</td>
                <td>{transaction.FlightRecords.FlightRecord[0].TotalAmount}</td>
                <td>
                  <AppLink
                    linkText={transaction.ReferenceTxId}
                    isLink
                    target="_blank"
                    href={getFlightTicket(transaction.ReferenceTxId)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
FlightRescheduleList.propTypes = {
  flightReschedules: PropTypes.array.isRequired,
};

export default FlightRescheduleList;
